export default __webpack_public_path__ + "static/media/29.1ccabe66.jpg";